import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=b8645414&"
import script from "./Product.vue?vue&type=script&lang=js&"
export * from "./Product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8645414')) {
      api.createRecord('b8645414', component.options)
    } else {
      api.reload('b8645414', component.options)
    }
    module.hot.accept("./Product.vue?vue&type=template&id=b8645414&", function () {
      api.rerender('b8645414', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/Product.vue"
export default component.exports